import React from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import { formatDateToThai } from "../../../../../utils/date.utils";
import { numberFormat } from "../../../../../utils/common";
import { thaiMonths } from "../../../../../utils/monthThai";

const Form10 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
}) => {
  const condition = dataReportDetail?.condition;

  const {
    day: start_leave_day,
    month: start_leave_month,
    year: start_leave_year,
  } = formatDateToThai(condition?.start_date ?? null);

  const {
    day: end_leave_day,
    month: end_leave_month,
    year: end_leave_year,
  } = formatDateToThai(condition?.end_date ?? null);

  // เดือนมกราคม index = 0 เป็น falsy — ต้องเช็ค null ไม่ใช่ truthy
  const monthName = (m: number | null | undefined) =>
    m == null ? null : thaiMonths[m];

  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        form_code={"บค. ๒๔"}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* ข้าพเจ้า / นามสกุล */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ข้าพเจ้า"}
          end_label={null}
          length={100}
          value={dataEmployee?.first_name}
          isParagraph={true}
        />
        <RenderValue
          start_label={"นามสกุล"}
          end_label={null}
          length={100}
          value={dataEmployee?.last_name}
          isParagraph={false}
        />
      </div>
      {/* ตำแหน่ง / เลขที่ / สังกัด */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={90}
          value={dataEmployee?.work_history?.position_name}
          isParagraph={false}
        />
        <RenderValue
          start_label={"เลขที่"}
          end_label={null}
          length={60}
          value={dataEmployee?.employee_no}
          isParagraph={false}
        />
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={60}
          value={"IBSC"}
          isParagraph={false}
        />
      </div>
      {/* แผนงาน / เงินเดือน */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"แผนงาน"}
          end_label={null}
          length={70}
          value={dataEmployee?.department?.department_name_th}
          isParagraph={false}
        />
        <RenderValue
          start_label={"ได้รับเงินเดือน ๆ ละ"}
          end_label={"บาท มีความประสงค์"}
          length={70}
          value={
            condition?.salary_amount
              ? numberFormat(condition?.salary_amount, 0, 0)
              : null
          }
          isParagraph={false}
        />
      </div>
      {/* ชื่อคู่สมรส / ตำแหน่งคู่สมรส */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ขอลาติดตามคู่สมรสชื่อ"}
          end_label={null}
          length={90}
          value={[condition?.spouse, condition?.spouse_last_name]
            .filter(Boolean)
            .join(" ")}
          isParagraph={false}
        />
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={90}
          value={condition?.position_name}
          isParagraph={false}
        />
      </div>
      {/* สังกัด / แผนงาน ของคู่สมรส */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={90}
          value={condition?.affiliation_name}
          isParagraph={false}
        />
        <RenderValue
          start_label={"แผนงาน"}
          end_label={"ซึ่งไปปฏิบัติงาน"}
          length={90}
          value={condition?.department_name}
          isParagraph={false}
        />
      </div>
      {/* ณ ประเทศ / มีกำหนด ปี เดือน วัน */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ณ ประเทศ"}
          end_label={null}
          length={90}
          value={condition?.country}
          isParagraph={false}
        />
        <RenderValue
          start_label={"มีกำหนด"}
          end_label={"ปี"}
          length={30}
          value={condition?.scheduled_year}
          isParagraph={false}
        />
        <RenderValue
          start_label={null}
          end_label={"เดือน"}
          length={40}
          value={condition?.scheduled_month}
          isParagraph={false}
        />
        <RenderValue
          start_label={null}
          end_label={"วัน"}
          length={30}
          value={condition?.scheduled_day}
          isParagraph={false}
        />
      </div>
      {/* ตั้งแต่วันที่ - ถึงวันที่ */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ตั้งแต่วันที่"}
          end_label={null}
          length={20}
          value={start_leave_day ?? null}
          isParagraph={false}
        />
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={monthName(start_leave_month)}
          isParagraph={false}
        />
        <RenderValue
          start_label={"พ.ศ."}
          end_label={null}
          length={25}
          value={start_leave_year ?? null}
          isParagraph={false}
        />
        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={20}
          value={end_leave_day ?? null}
          isParagraph={false}
        />
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={monthName(end_leave_month)}
          isParagraph={false}
        />
        <RenderValue
          start_label={"พ.ศ."}
          end_label={null}
          length={25}
          value={end_leave_year ?? null}
          isParagraph={false}
        />
      </div>
      {/* ครั้งสุดท้าย — ยังไม่มีข้อมูลจากระบบ ปล่อยเส้นว่างให้กรอกมือ */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ครั้งสุดท้ายข้าพเจ้าได้ลาติดตามคู่สมรสไปประเทศ"}
          end_label={null}
          length={140}
          value={null}
          isParagraph={false}
        />
      </div>
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"เป็นเวลา"}
          end_label={"ปี"}
          length={20}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={null}
          end_label={"เดือน"}
          length={25}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={null}
          end_label={"วัน"}
          length={20}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={" เมื่อวันที่"}
          end_label={null}
          length={20}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={35}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={"พ.ศ."}
          end_label={null}
          length={20}
          value={null}
          isParagraph={false}
        />
      </div>
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={
            "ในกรณีลาติดต่อกับครั้งก่อน รวมทั้งครั้งนี้ด้วย เป็นเวลา"
          }
          end_label={"ปี"}
          length={20}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={null}
          end_label={"เดือน"}
          length={25}
          value={null}
          isParagraph={false}
        />
        <RenderValue
          start_label={null}
          end_label={"วัน"}
          length={20}
          value={null}
          isParagraph={false}
        />
      </div>

      {/* signature*/}
      <div className="w-full ml-24">
        <SignaturePrint
          title={"นมัสการมาด้วยความเคารพ"}
          prefix={`ลงชื่อ`}
          position={""}
          isDate={false}
          isPosition={false}
          data={{}}
        />
      </div>
      <div className="w-full">
        <CommentPrint
          title={"ความเห็นของผู้บังคับบัญชาชั้นต้น"}
          isCheckBoxApprove={false}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            isApprove: data?.leave_status
              ? data.leave_status === "approve third"
              : null,
            comment: data.leave_approve_first_comment ?? "",
          }}
          lengthDot={150}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>

        <CommentPrint
          title={"คำสั่งของผู้มีอำนาจอนุญาต"}
          isCheckBoxApprove={true}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            // ยังไม่มีสถานะ → ไม่ติ๊กช่องใดเลย (เส้นว่างเหมือนแบบฟอร์มกระดาษ)
            isApprove: data?.leave_status
              ? data.leave_status === "approve third"
              : null,
            // ผู้มีอำนาจอนุญาต = ผู้อนุมัติลำดับสาม (ตามแบบเดียวกับ Form03)
            comment: data.leave_approve_third_comment ?? "",
          }}
          lengthDot={150}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>
      </div>
    </div>
  );
};

export default Form10;
